

"use client";

import Image from "next/image";
import Link from "next/link";
import { Classes } from "@/db/classesData";
import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { activities } from "@/db/activityData";

const ClassesSection = () => {
  const swiperRef = useRef<any>(null);

  return (
    <section className="home-special-course">
      <div className="container-fluid">
        <div className="section-tittle text-center">
          <h2>Our Extra-Curricular</h2>
          <p>
            Our extra-curricular activities encourage students to explore their interests, develop new skills, and grow through teamwork and creative activities.
          </p>
        </div>

        <div className="position-relative">
          <Swiper
            ref={swiperRef}
            modules={[Navigation, Autoplay]}
            loop={true}
            // centeredSlides={true}
            spaceBetween={30}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            navigation={{
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }}
            breakpoints={{
              0: { slidesPerView: 1 },
              576: { slidesPerView: 2 },
              992: { slidesPerView: 3 },
              1200: { slidesPerView: 4 },
            }}
            className="home-course-slider"
          >
            {activities.slice(0, 6).map((item) => (
              <SwiperSlide key={item.id}>
                <div className="single-home-special-course">
                  <div className="course-img">
                    <Image
                      src={item.image}
                      alt={item.name}
                      width={400}
                      height={500}
                      className="img-fluid img-width"
                    />

                    <div className="course-content">
                      <h2>{item.name}</h2>
                      <p>{item.description}</p>
                      {/* <Link href="#" className="box-btn">
                        Read More
                      </Link> */}
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Custom Navigation */}
          <div className="swiper-button-prev">
            <FiChevronLeft />
          </div>
          <div className="swiper-button-next">
            <FiChevronRight />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClassesSection;